// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3DMTs","subheader":"ReorderModal_subheader__JQ1RN","listWrap":"ReorderModal_listWrap__3aVVV"};